import React, { useState, useEffect, useCallback } from 'react';
import { Popover } from '@tinper/next-ui'
import { reaction } from 'mobx'
import { observer } from 'mobx-react'
import _ from 'lodash';
import render from 'ynf-core-engine/render' // 组件库名
import { v4 as uuid } from 'uuid';

import { getFieldId, getObjField } from '../../utils/tools';
import './index.less';
const X_LIB_CODE = 'ynf-lib-base'

// 统一获取智能搜索的列
function setSmartSearchColumn (referRootStore: any) {
  const { metaDataObj } = referRootStore
  let tableView: any = {}
  const BillTemplate = metaDataObj.gridMeta.nfwFeData.children.find((e: any) => e.controlType === 'BillTemplate')

  if (metaDataObj.gridMeta.nfwFeData) { // 新协议
    if (['Table'].includes(metaDataObj.refEntity.cTpltype)) {
      // tableView = metaDataObj.gridMeta.nfwFeData.children.find((e: any) => e.controlType === 'BillTemplate').children.find((e: any) => e.controlType === 'Table')
      tableView = getObjField(BillTemplate, 'children', 'controlType', 'Table')
    } else if (['Tree'].includes(metaDataObj.refEntity.cTpltype)) {
      if (metaDataObj.gridMeta.nfwFeData.children.find((e: any) => e.controlType === 'BillTemplate').controls) {
        tableView.children = BillTemplate.controls
        return tableView
      } else { // ynf协议
        // tableView = metaDataObj.gridMeta.nfwFeData.children.find((e: any) => e.controlType === 'BillTemplate').children.find((e: any) => e.controlType === 'Tree')
        tableView = getObjField(BillTemplate, 'children', 'controlType', 'Tree')
        const fieldArr = [referRootStore.referInputProps.refReturn]
        const fieldMap = metaDataObj.gridMeta.nfwFeData.children.find((e: any) => e.controlType === 'datasourceList').children.find((e: any) => e.dataPattern == 'TREE').fieldsArr.reduce((acc: any, obj: any) => {
          acc[obj.field] = obj; // 使用 field 属性作为键，整个对象作为值
          return acc;
        }, {})
        tableView.children = fieldArr.map((field: string) => ({
          libCode: 'ynf-lib-base',
          visible: true,
          caption: fieldMap[field].caption,
          orderNum: 1,
          serialCode: '1868629993090187270',
          store: 'tableStore',
          required: false,
          parentSerialCode: '1868629993090187269',
          compType: 'xcontrol',
          controlType: 'Input',
          iColWidth: 1,
          storeField: 'name',
          alias: 'input3',
          disabled: false,
          value: `mobx://rowStore.getValue('name')`
        }))
      }
    } if (['TreeTable'].includes(metaDataObj.refEntity.cTpltype)) {
      // tableView = metaDataObj.gridMeta.nfwFeData.children.find((child: any) => child.controlType === 'BillTemplate').children.find((e: any) => e.controlType === 'Layout').children.find((e: any) => e.controlType === 'Table')
      tableView = getObjField(BillTemplate, 'children', 'controlType', 'Table')
    }
  }
  return tableView
}

const getTableColumn = (props: any) => {
  let columns = setSmartSearchColumn(props.referRootStore).children || []
  columns = columns.filter((e: any) => e.cControlType !== 'ToolBar').map((item: any) => { // columns metaData元数据
    item = JSON.parse(JSON.stringify(item))
    item.alias = 'smartSearch' + uuid();
    item.sorter = true; // 列排序
    item.readOnly = true; // 全都是只读不能修改
    // item.store = referTableStore;
    item.caption_resid = item.cShowCaptionResid;
    // 该列不展示
    if (item.bShowIt === false || item.visible === false) item.visible = false;
    else item.visible = true;

    if (item.modelPath) item.storeField = item.modelPath[item.modelPath.length - 1];
    if (item.controlType === 'PictureUpload' || item.controlType === 'Upload') item.showType = '2';
    if (item.controlType === 'Enumerate') item.enumData = `mobx://rootStore.pageStore.enumData.${item.enumType}`;
    return item
  }) || [];
  return columns
}

const getTableConfig = (props: any) => {
  const { fieldid, fieldidPrefix } = props.inputProps || {};

  const columns = getTableColumn(props);
  // columns.columns.unshift(this.setFavorite(value)) // 收藏列
  const config = {
    fieldid,
    fieldidPrefix,
    store: props.referRootStore.smartSearchStore,
    libCode: X_LIB_CODE, // 组件库
    controlType: 'Table', // 组件类型
    alias: 'smartSearch', // 组件唯一标识 有path是树表, 树表切换时不能用同一个alias
    children: columns,
    compType: 'xcontainer',
    isSort: true, // 表格排序
    isSingleFind: false, // 该列是否启用查找定位
    readOnly: true,
    showColumnSetting: true,
    // rowSelection: JSON.stringify({ multiple: false }),
    autoCheckedByClickRows: true, // 表格行点击事件，是否自动勾选
    lockable: false // 是否开启锁定列功能
    // onRowClick: (data: any) => rowClick(props, data),
    // getSelectedDataFunc: this.getSelectedDataFunc,
    // onRowHrefClick: ({ rowData, rowIndex }) => { this.onRowHrefClick({ rowData, rowIndex, columns }) }
  }
  return config;
}

const SmartSearch = observer((props: any) => {
  const { inputProps, referRootStore, referRef, inputValue } = props
  const [content, setContent] = useState()
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const dom = render({ ...getTableConfig(props) }, { rootStore: referRootStore })
    setContent(dom)
  }, [])

  useEffect(() => {
    const select = reaction(() => referRootStore.smartSearchStore.currentActiveRowKey, (val: any) => {
      if (val) {
        const node = referRootStore.smartSearchStore.getActiveByRowKey(val)
        if (inputProps.multiple) {
          const currValue = referRootStore.referInputProps.value

          const obj: any = {}
          referRootStore.setData([...currValue, node].reduce((acc, curr) => {
            if (!curr || obj[curr[inputProps.valueField]]) return acc
            obj[curr[inputProps.valueField]] = true
            return [...acc, curr]
          }, []))
        } else {
          referRootStore.setData([node])
        }
        referRootStore.referInput.setState({inputValue: ''})
        setVisible(false)
      }
    });

    return () => {
      select()
    };
  }, []);

  const searchThrottle = useCallback(_.throttle((inputValue: string) => {
    referRootStore.searchData({ type: 'smartSearch', params: { likeValue: inputValue } })
    referRootStore.smartSearchStore.currentActiveRowKey = ''
    !visible && setVisible(true)
  }, 1000), [])

  useEffect(() => {
    if (inputValue) {
      searchThrottle(inputValue);
    }
  }, [inputValue])

  return <Popover
    fieldid={`${getFieldId(inputProps)}_search`}
    hideArrow={false}
    rootClose={true}
    getPopupContainer={() => referRef.current}
    overlayClassName='ynf-refer-popover'
    placement='bottomLeft'
    destroyTooltipOnHide={false}
    trigger='click'
    visible={visible}
    onHide={() => setVisible(false)}
    content={<div className='smartsearch-table' style={{ width: referRef.current?.offsetWidth < 300 ? 300 : referRef.current?.offsetWidth }}>{content}</div>}>
  </Popover>
})

export default React.memo(SmartSearch)
